/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ParticipantLite } from './participantLite';
import type { SegmentSampleOut } from './segmentSampleOut';

export interface SpeakerOut {
  speaker_label: string;
  participant: ParticipantLite | null;
  talk_time_ms: number;
  sample_segments: SegmentSampleOut[];
}
